<template>
  <div class="text-center" style="margin-top: 5px;">
    <b-spinner label="Spinning"></b-spinner>
  </div>
</template>


<script>
export default {
  data: function() {
    return {};
  },
  computed: {},
  beforeMount: function() {},
  methods: {},
  components: {},
};
</script>